export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/environments/environment.ts